module.exports = __webpack_public_path__ + "img/check-white.cc27c914.svg";